import { React } from "react";
import { Link } from "react-router-dom";
//
import logoAmebo from "../../../assets/logo/logo2.png";
//
import { FaUserAlt } from "react-icons/fa";
import { FaHandsHelping, FaClipboardList } from "react-icons/fa";
import { FaDeleteLeft } from "react-icons/fa6";
import { RiLockPasswordFill } from "react-icons/ri";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

const MenuProv = ({ viewSee }) => {
  const navigate = useNavigate();

  const changeviewprov = (e, page) => {
    e.preventDefault();
    viewSee(page);
  };

  const handleLogout = () => {
    Cookies.remove("token");
    Cookies.remove("adminType");
    sessionStorage.removeItem("Data");
    navigate("/");
  };

  return (
    <div className="allmenuleft">
      <div className="boxlogoprov">
        <img className="logomenuleftprov" src={logoAmebo} alt="logo" />
      </div>
      <div className="boxallbuttonprov">
        <div
          className="boxbuttonprov"
          onClick={(e) => changeviewprov(e, "Perfil")}
        >
          <p className="letterbuttonprov">
            <FaUserAlt className="iconprov" />
            Perfil
          </p>
        </div>
        <div
          className="boxbuttonprov"
          onClick={(e) => changeviewprov(e, "Factura")}
        >
          <p className="letterbuttonprov">
            <FaHandsHelping className="iconprov" />
            Subir factura
          </p>
        </div>
        <Link to="/portal-proveedor/mis-facturas">
          <div className="boxbuttonprov">
            <p className="letterbuttonprov">
              <FaClipboardList className="iconprov" />
              Mis facturas
            </p>
          </div>
        </Link>
        <div
          className="boxbuttonprov"
          onClick={(e) => changeviewprov(e, "Contraseña")}
        >
          <p className="letterbuttonprov">
            <RiLockPasswordFill className="iconprov" />
            Cambiar contraseña
          </p>
        </div>
        <div className="boxbuttonprov" onClick={handleLogout}>
          <p className="letterbuttonprov">
            <FaDeleteLeft className="iconprov" />
            Salir
          </p>
        </div>
      </div>
    </div>
  );
};

export default MenuProv;
